// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2-Rt_","title":"Info_title__al_Ae","links":"Info_links__1DfWK","link":"Info_link__2HXbX","logo":"Info_logo__vYUlI"};